var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6500_10873)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6500_10873)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6500_10873",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6500_10873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#D3BA69"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6500_10873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1569 13.6585L19.2271 12.6763L6.02598 18.4476L4 22.5L10.8787 24.4756L25.1214 18.1417L23.1569 13.6585Z",
    fill: "#FFE694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1571 13.6587L9.89453 19.5539L10.879 24.4757L25.1216 18.1419L23.1571 13.6587Z",
    fill: "#EECF68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89344 19.5539L6.02516 18.4478L4 22.5002L10.8779 24.4758L9.89344 19.5539Z",
    fill: "#B38E28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0358 15.6336L26.106 14.6509L12.9049 20.4226L10.8789 24.4754L17.7575 26.4493L32.0002 20.1159L30.0358 15.6336Z",
    fill: "#FFE694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0361 15.6338L16.7734 21.5277L17.7578 26.4495L32.0005 20.1161L30.0361 15.6338Z",
    fill: "#EECF68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7731 21.5277L12.9049 20.4229L10.8789 24.4757L17.7575 26.4496L16.7731 21.5277Z",
    fill: "#B38E28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6785 10.533L21.7495 9.55078L9.68147 14.8546L7.65625 18.907L14.535 20.8818L27.6438 15.0156L25.6785 10.533Z",
    fill: "#FFE694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6787 10.5327L13.5508 15.9596L14.5352 20.8815L27.644 15.0154L25.6787 10.5327Z",
    fill: "#EECF68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5506 15.9598L9.68147 14.8545L7.65625 18.9069L14.535 20.8817L13.5506 15.9598Z",
    fill: "#B38E28"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6500_10873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6500_10873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6500_10873"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.9e8013db0f30c2d1b6f916fefeaf632e.svg";
export { ForwardRef as ReactComponent };